// extracted by mini-css-extract-plugin
module.exports = {"resetPassword":"styles__resetPassword___kSc5B"};